import { render, staticRenderFns } from "./AuthorizeForm.vue?vue&type=template&id=583b952c&scoped=true"
import script from "./AuthorizeForm.vue?vue&type=script&lang=js"
export * from "./AuthorizeForm.vue?vue&type=script&lang=js"
import style0 from "./AuthorizeForm.vue?vue&type=style&index=0&id=583b952c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583b952c",
  null
  
)

export default component.exports